import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store";
import { remoteSignout } from "../../store/User";
import Loading from "../Loading";

const RemoteLogoutPage = function() {
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    dispatch(remoteSignout());
  }, [dispatch]);

  return (<Loading isLoading={true} />);
}

export default RemoteLogoutPage;